import history from './../../history';
import moment from 'moment';
import React from 'react';
import { toast } from 'react-toastify';
import Auth from '../../components/auth/auth'

export const API_URL = process.env.REACT_APP_BACKEND_BASE_URL;

export async function edyncareFetch (dispatch, getState, API_NAME, REQUEST_METHOD, METHOD_BODY, AdminActionTypes, SUCCESS_MESSAGE) {

  dispatch(actionCreator(AdminActionTypes.REQUEST));
  let METHOD_OBJECT = null; 
  if (METHOD_BODY === 'post' || METHOD_BODY === 'put') {
    METHOD_OBJECT = {
      method: REQUEST_METHOD,
      body: METHOD_BODY,
      headers: await jsonApiHeader('application/json'),
    };
  } else {
    METHOD_OBJECT = {
      method: REQUEST_METHOD,
      headers: await jsonApiHeader('application/json'),
    };
  }

  if (API_NAME && METHOD_OBJECT) {
    return fetch(API_NAME, METHOD_OBJECT)
    .then(checkHttpStatus)
    .then(function(response) {
      dispatch(actionCreator(AdminActionTypes.SUCCESS, response));
      if (SUCCESS_MESSAGE) showSuccessMessage(SUCCESS_MESSAGE);
    })
    .catch(function(error) {        
      console.log('error', error);        
      dispatch(actionCreator(AdminActionTypes.FAILURE, error));
    }); 
  }
}

const REQUEST = 'REQUEST';
const SUCCESS = 'SUCCESS';
const FAILURE = 'FAILURE';
/** Action types creator for REQUEST / SUCCESS / FAILURE action types. */
export function createRequestActionTypes(base) {
  return [REQUEST, SUCCESS, FAILURE].reduce((requestTypes, type) => {
    requestTypes[type] = `${base}_${type}`;
    return requestTypes;
  }, {});
}

/** API request headers. */
export const jsonApiHeader = async (ContentType, accessToken) => {
  if (!accessToken) {
    try {
      const auth = new Auth()
      accessToken = await auth.getAccessTokenAsync()  
    } catch (error) {

    }
  } 
  return ({
    'Content-Type': ContentType ? ContentType : 'application/json',
    'Authorization': accessToken ? `Bearer ${accessToken}` : '',
  });
};

/** Set action type and payload. */
export function actionCreator(actionType, data) {
  return {
    type: actionType,
    payload: data,
  };
}

/** Checks the API response status. */
export function checkHttpStatus(response) {
  if (response.status >= 200 && response.status < 204) {
    return response.json();
  } else if (response.status === 204) {
    return true;
  } else if (response.status >= 400 && response.status < 500) {
    return response.json();
  } else {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
}

/** Show error message. */
export const showErrorMessage = (message) => {
  return (
    toast.error(message, {
      position: toast.POSITION.TOP_RIGHT,
    })
  );
};

/** Show success message. */
export const showSuccessMessage = (message) => {
  return (
    toast.success(message, {
      position: toast.POSITION.TOP_RIGHT,
    })
  );
};

/** Show warning message. */
export const showWarningMessage = (message) => {
  return (
    toast.warning(message, {
      position: toast.POSITION.TOP_RIGHT,
    })
  );
};
